export default class RequestTracker {
  startTime: number;
  endTime?: number;
  controller: AbortController;

  constructor(controller: AbortController) {
    this.controller = controller;
    this.startTime = Date.now();
  }

  abort() {
    this.controller.abort();
  }

  finish() {
    this.endTime = Date.now();
  }
}
